import React from 'react'
import { Navigate } from 'react-router'

import Login from '../pages/auth/Login'
import ForgotPassword from "../pages/auth/ForgotPassword"
import CheckExternalMenu from '../pages/auth/CheckExternalMenu'

import Pos from '../pages/main/pos/Index'
import PosCreateUpdate from '../pages/main/pos/CreateUpdate'
import SubscriptionAccount from '../pages/main/subscription/Index'

import Hello from '../pages/main/dashboard/Hello'
import Brand from '../pages/main/brand/Index'
import Help from '../pages/main/help/Index'

import AnalyticsDashboard from '../pages/main/analytics/dashboard/Index'
import AnalyticsDaily from '../pages/main/analytics/daily/Index'
import AnalyticsWeekly from '../pages/main/analytics/weekly/Index'
import AnalyticsMonthly from '../pages/main/analytics/monthly/Index'
import AnalyticsUnit from '../pages/main/analytics/unit/Index'
import AnalyticsDelivery from '../pages/main/analytics/delivery/Index'
import AnalyticsLfl from '../pages/main/analytics/lfl/Index'
import AnalyticsRfm from '../pages/main/analytics/rfm/Index'
import AnalyticsAbc from '../pages/main/analytics/abc/Index'
import AnalyticsBcg from '../pages/main/analytics/bcg/Index'
import AnalyticsFoodCost from '../pages/main/analytics/foodCost/Index'
import AnalyticsExpenseAnalysis from '../pages/main/analytics/expenseAnalysis/Index'
import AnalyticsRecommendedProducts from '../pages/main/analytics/recommendedProducts/Index'
import AnalyticsInventoryAbc from '../pages/main/analytics/inventoryAbc/Index'
import AnalyticsFrozenFunds from '../pages/main/analytics/frozenFunds/Index'
import AnalyticsComparison from '../pages/main/analytics/comparison/Index'
import AnalyticsHeatMap from '../pages/main/analytics/heatMap/Index'
import AnalyticsPopMetrics from '../pages/main/analytics/popMetrics/Index'
import AnalyticsAiInsights from '../pages/main/analytics/aiInsights/Index'
import AnalyticsAiForecast from '../pages/main/analytics/aiForecast/Index'
import AiAssistant from '../pages/main/ai/Index'
import AnalyticsPurchasePriceChanges from '../pages/main/analytics/purchasePriceChanges/Index'
import AnalyticsPriceDynamics from '../pages/main/analytics/priceDynamics/Index'
import AnalyticsDiscounts from '../pages/main/analytics/discounts/Index'
import AnalyticsConstructor from '../pages/main/analytics/constructor/Index'

import FavoriteNavigation from '../pages/main/favoriteNavigation/Index'
import Hall from '../pages/main/halls/Index'
import HallScheme from '../pages/main/halls/Scheme'
import PreparationPlaces from '../pages/main/preparationPlaces/Index'
import PrintRoutes from '../pages/main/printRoutes/Index'
import Table from '../pages/main/tables/Index'
import OrderTypes from '../pages/main/orderTypes/Index'
import PaymentTypes from '../pages/main/paymentTypes/Index'
import CourierTypes from '../pages/main/courierTypes/Index'
import UserAttendanceTypes from '../pages/main/userAttendanceTypes/Index'
import Categories from '../pages/main/categories/Index'
import ProductCategories from '../pages/main/productCategories/Index'
import Comment from '../pages/main/comments/Index'
import AutoAddRule from '../pages/main/autoAddRule/Index'
import Element from '../pages/main/elements/Index'
import Product from '../pages/main/products/Index'
import Motivation from '../pages/main/motivations/Index'
import MotivationCreateUpdate from '../pages/main/motivations/CreateUpdate'
import EmployeeTimeRate from '../pages/main/employeeTimeRates/Index'
import EmployeeTimeRateCreateUpdate from '../pages/main/employeeTimeRates/CreateUpdate'
import WorkSchedule from '../pages/main/workSchedule/Index'
import WorkShiftType from '../pages/main/workShiftTypes/Index'
import PriceСhange from '../pages/main/products/PriceСhange'
import ProductCreateUpdate from '../pages/main/products/CreateUpdate'
import ProductStopList from '../pages/main/products/StopList'
import Employee from '../pages/main/employees/Index'
import EmployeeCreateUpdate from '../pages/main/employees/CreateUpdate'
import Menu from '../pages/main/menu/Index'
import QuickMenu from '../pages/main/quickMenu/Index'
import Supplier from '../pages/main/suppliers/Index'
import SuppliersTypes from '../pages/main/suppliersTypes/Index'
import Expense from '../pages/main/paymentPuposeTypes/Index'
import Cashbox from '../pages/main/cashbox/Index'
import Shift from '../pages/main/cashbox/Shift'
import Clients from '../pages/main/clients/Index'
import ClientsCards from '../pages/main/clients/Cards'
import ClientsCardsBatches from '../pages/main/clients/CardsBatches'
import Organizations from '../pages/main/organizations/Index'
import Terminals from '../pages/main/terminals/Index'
import Devices from '../pages/main/devices/Index'
import EmployeePositions from '../pages/main/employeePositions/Index'
import EmployeePositionsCreateUpdate from '../pages/main/employeePositions/CreateUpdate'
import EmployeeBonus from '../pages/main/employeeKPI/Index'
import MenuProductOrder from '../pages/main/menuProductOrder/Index'
import EmployeeSalary from '../pages/main/employeeSalary/Index'
import Cheques from '../pages/main/cheques/Index'
import ChequesRating from '../pages/main/cheques/Rating'
import GuestFeedbacks from '../pages/main/guestFeedbacks/Index'
import ChequesByClients from '../pages/main/cheques/ByClients'
import ChequesByCounterparties from '../pages/main/cheques/ByCounterparties'
import ChequesByCounterparty from '../pages/main/cheques/ByCounterparty'
import ChequeTemplateLegacy from '../pages/main/cheques/Template'
import ChequeTemplates from '../pages/main/chequeTemplates/Index'
import ChequeTemplatesCreateUpdate from '../pages/main/chequeTemplates/CreateUpdate'
import Synchronization from '../pages/main/onlineUsers/Synchronization'
import DeletionReasons from '../pages/main/deletionReasons/Index'
import ProductLabels from '../pages/main/productLabels/Index'
import TaxCategory from '../pages/main/taxCategories/Index'
import Attendances from '../pages/main/attendances/Index'

import PricePeriod from '../pages/main/priceList/pricePeriods/Index'
import PriceCategory from '../pages/main/priceList/PriceCategory/Index'

import DocumentsPrice from '../pages/main/documentsPrice/Index'
import DocumentsPriceCreateUpdate from '../pages/main/documentsPrice/CreateUpdate'
import DocumentsPricePreview from '../pages/main/documentsPrice/Preview'

import DocumentsIn from '../pages/main/documentsIn/Index'
import DocumentsInCreateUpdate from '../pages/main/documentsIn/CreateUpdate'
import DocumentsInPreview from '../pages/main/documentsIn/Preview'

import DocumentsReturn from '../pages/main/documentsReturn/Index'
import DocumentsReturnCreateUpdate from '../pages/main/documentsReturn/CreateUpdate'
import DocumentsReturnPreview from '../pages/main/documentsReturn/Preview'

import DocumentsImplementation from '../pages/main/documentsImplementation/Index'
import DocumentsImplementationCreateUpdate from '../pages/main/documentsImplementation/CreateUpdate'
import DocumentsImplementationPreview from '../pages/main/documentsImplementation/Preview'

import DocumentPreparation from '../pages/main/documentsPreparation/Index'
import DocumentPreparationCreateUpdate from '../pages/main/documentsPreparation/CreateUpdate'
import DocumentPreparationPreview from '../pages/main/documentsPreparation/Preview'

import DocumentBreakdown from '../pages/main/documentsBreakdown/Index'
import DocumentBreakdownCreateUpdate from '../pages/main/documentsBreakdown/CreateUpdate'
import DocumentBreakdownPreview from '../pages/main/documentsBreakdown/Preview'

import DocumentDisasembly from '../pages/main/documentsDisasembly/Index'
import DocumentDisasemblyCreateUpdate from '../pages/main/documentsDisasembly/CreateUpdate'
import DocumentDisasemblyPreview from '../pages/main/documentsDisasembly/Preview'

import Orders from '../pages/main/documentsOrders/Index'
import OrdersCreateUpdate from '../pages/main/documentsOrders/CreateUpdate'
import OrdersPreview from '../pages/main/documentsOrders/Preview'

import ServiceDocumentsIn from '../pages/main/service/documentsIn/Index'
import ServiceDocumentsInPreview from '../pages/main/service/documentsIn/Preview'
import ServiceDocumentsInReport from '../pages/main/service/documentsInReport/Index'
import ServiceReturnsIn from '../pages/main/service/returnsIn/Index'
import ServiceReturnsInPreview from '../pages/main/service/returnsIn/Preview'

import ServiceOrders from '../pages/main/service/documentsOrders/Index'
import ServiceOrdersPreview from '../pages/main/service/documentsOrders/Preview'

import InventoryTest from "../pages/main/inventory/Main"
import InventoryTest2 from "../pages/main/inventory/MainPreview"

import InventoryIndex from "../pages/main/inventory/Index"
import InventoryCreateUpdate from "../pages/main/inventory/CreateUpdate"
import InventoryPreview from "../pages/main/inventory/Preview"

import WriteOff from '../pages/main/writeOff/Index'
import WriteOffCreateUpdate from '../pages/main/writeOff/CreateUpdate'
import WriteOffPreview from '../pages/main/writeOff/Preview'

import WmsShifts from '../pages/main/wms/cashbox/Shifts'

import Wms from '../pages/main/wms/Index'
import WmsTransfer from '../pages/main/wms/transfer/Index'
import WmsTransferCreateUpdate from '../pages/main/wms/transfer/CreateUpdate'
import WmsTransferPreview from '../pages/main/wms/transfer/Preview'
import WmsTransferReturn from '../pages/main/wms/transfer/Return'

import WmsTransferToBranch from '../pages/main/wms/transferBrach/Index'
import WmsTransferToBranchCreate from '../pages/main/wms/transferBrach/CreateUpdate'
import WmsTransferToBranchPreview from '../pages/main/wms/transferBrach/Preview'

import WmsTransferBranchDocumentIn from '../pages/main/wms/documentsIn/Index'
import WmsTransferBranchDocumentInPreview from '../pages/main/wms/documentsIn/Preview'

import WmsTransferToPos from '../pages/main/service/transfer/Index'
import WmsTransferToPosCreate from '../pages/main/service/transfer/CreateUpdate'
import WmsTransferToPosPreview from '../pages/main/service/transfer/Preview'

import ReportPosSafe from '../pages/main/reports/PosSafe'
import ReportPosBank from '../pages/main/reports/PosBank'
import ReportAverageCheque from '../pages/main/reports/AverageCheque'
import ReportBalance from '../pages/main/reports/Balance'
import ReportCalculation from '../pages/main/reports/Calculation'
import ReportClients from '../pages/main/reports/ClientDebt'
import ReportClientsInnerDebts from '../pages/main/reports/ClientDebtInner'
import ReportOrganizations from '../pages/main/reports/Organizations'
import ReportOrganizationsInnerDebts from '../pages/main/reports/OrganizationsInnerDebts'
import ReportEmployee from '../pages/main/reports/Employee'
import ReportExpenses from '../pages/main/reports/Expenses'
import ReportGrossIncome from '../pages/main/reports/GrossIncome'
import ReportIncomes from '../pages/main/reports/Incomes'
import ReportMenu from '../pages/main/reports/Menu'
import ReportMenu2 from '../pages/main/reports/Menu2'
import ReportOlap from '../pages/main/reports/olap/Index'
import ReportSuppliers from '../pages/main/reports/Supplier'
import ReportSuppliersInner from '../pages/main/reports/SupplierInnerDebt'
import ReportSupplierMovements from '../pages/main/reports/SupplierMovements'
import ReportEmployees from '../pages/main/reports/EmployeeDebt'
import ReportEmployeesInner from '../pages/main/reports/EmployeeDebtInner'
import ReportProducts from '../pages/main/reports/Products'
import ReportSales from '../pages/main/reports/Sales'
import ReportPreparation from '../pages/main/reports/Preparation'
import ReportCashFlow from '../pages/main/reports/CashFlow'
import ReportSummary from '../pages/main/reports/Summary'
import ReportSummaryCheques from '../pages/main/reports/SummaryCheques'
import ReportZ from '../pages/main/reports/ReportZ'
import ReportCheckPoint from '../pages/main/reports/CheckPoint'
import ReportWriteOff from '../pages/main/reports/WriteOff'

import ChainPlans from '../pages/main/chain/reports/ChainPlans'
import ChainBalance from '../pages/main/chain/reports/ChainBalance'
import ChainElementSales from '../pages/main/chain/reports/ChainElementSales'
import ChainElementIncomes from '../pages/main/chain/reports/ChainElementIncomes'
import ChainProductSales from '../pages/main/chain/reports/ChainProductSales'
import ChainWmsTransferPos from '../pages/main/chain/reports/ChainWmsTransferPos'
import ChainWmsTransferPosSummary from '../pages/main/chain/reports/ChainWmsTransferPosSummary'

import ChainSales from '../pages/main/chain/reports/ChainSales'
import ChainHours from '../pages/main/chain/reports/ChainHours'
import ChainPlanFact from '../pages/main/chain/reports/ChainPlanFact'
import ChainContourMarket from '../pages/main/chain/reports/ChainContourMarket'
import ChainChequeRating from '../pages/main/chain/reports/ChainChequeRating'
import ChainServiceRating from '../pages/main/chain/reports/ChainServiceRating'
import ChainDeliveryTracking from '../pages/main/chain/reports/ChainCourierTracking'
import ChainExpenses from '../pages/main/chain/reports/ChainExpenses'
import ChainProfit from '../pages/main/chain/reports/ChainProfit'
import ChainWriteOffs from '../pages/main/chain/reports/ChainWriteOffs'
import ChainPayments from '../pages/main/chain/reports/ChainPayments'
import ChainLosses from '../pages/main/chain/reports/ChainLosses'

// KPI GROUP
import KpiGroups from '../pages/main/kpi/KpiGroup'
import KpiTypes from '../pages/main/kpi/KpiType'
import KpiScores from '../pages/main/kpi/KpiScore'

// FINANCE
import FinanceAccounts from '../pages/main/finance/accounts/Index'
import FinanceAccountTransactions from '../pages/main/finance/accounts/Transactions'
import FinanceProfitLoss from '../pages/main/finance/ProfitLoss'
import FinanceBalanceSheet from '../pages/main/finance/BalanceSheet'
import FinanceProductProfitability from '../pages/main/finance/ProductProfitability'
import FinanceFixedAssets from '../pages/main/fixedAssets/Index'

// notification
import TelegramSending from '../pages/main/notifications/telegramBot/Index'
import SmsSending from '../pages/main/notifications/sms/Index'
import SmsTemplates from '../pages/main/notifications/smsTemplates/Index'
import NotificationCenter from '../pages/main/notifications/center/Index'
import NotificationSettings from '../pages/main/notifications/settings/Index'
import SmsMessages from '../pages/main/notifications/smsMessages/Index'
import StockAlerts from '../pages/main/stockAlerts/Index'
import AuditLogs from '../pages/main/auditLogs/Index'
import SetupHealth from '../pages/main/setupHealth/Index'

// Settings
import ServiceRatingTemplates from '../pages/main/serviceRatingTemplates/Index'

import Payment from '../pages/main/payment/Payment'

import Loyalty from '../pages/main/loyalty/Index'
import LoyaltyCreateUpdateAmount from '../pages/main/loyalty/CreateUpdateAmount'
import LoyaltyCreateUpdateSaving from '../pages/main/loyalty/CreateUpdateSaving'
import LoyaltyCreateUpdateVisit from '../pages/main/loyalty/CreateUpdateVisit'

import Discount from '../pages/main/discount/Index'
import DiscountCreatePromoWizard from '../pages/main/discount/CreatePromoWizard'
import DiscountCreateUpdateDish from '../pages/main/discount/CreateUpdateDish'
import DiscountCreateUpdateManual from '../pages/main/discount/CreateUpdateManual'
import DiscountCreateUpdateCheque from '../pages/main/discount/CreateUpdateCheque'
import DiscountCreateUpdateFirstOrder from '../pages/main/discount/CreateUpdateFirstOrder'
import DiscountCreateUpdateProductManual from '../pages/main/discount/CreateUpdateProductManual'
import DiscountCreateUpdateMenuPromo from '../pages/main/discount/CreateUpdateMenuPromo'
import DiscountCreateUpdateBogo from '../pages/main/discount/CreateUpdateBogo'
import DiscountCreateUpdateGift from '../pages/main/discount/CreateUpdateGift'
import DiscountCreateUpdateDeliveryDiscount from '../pages/main/discount/CreateUpdateDeliveryDiscount'

import DiscountPromocodes from '../pages/main/discountPromocodes/Index'
import DiscountPromocodesReport from '../pages/main/discountPromocodes/Report'

import Calendar from '../pages/main/calendar/Index'

import ExternalGroups from '../pages/main/external/Group'
import ExternalMenu from '../pages/main/external/Menu'
import ExternalDeliveryRules from '../pages/main/external/DeliveryRules'
import ExternalDeliveryZones from '../pages/main/external/DeliveryZones'
import TelegramBots from '../pages/main/external/TelegramBots'
import WebsiteBuilder from '../pages/main/external/WebsiteBuilder'
import MobileAppBuilder from '../pages/main/external/MobileAppBuilder'
import SelfOrderBuilder from '../pages/main/external/SelfOrderBuilder'
import IntegrationGroup from '../pages/main/external/Integration'
import IntegrationUpdate from '../pages/main/external/IntegrationUpdate'
import IntegrationMenuCheck from '../pages/main/external/IntegrationMenuCheck'
import ExternalCallCenter from '../pages/main/external/CallCenter'
import ExternalQrMenuTable from '../pages/main/external/QrMenuTable'
import ExternalPosOrders from '../pages/main/external/PosOrders'
import ExternalCouriers from '../pages/main/external/ExternalCouriers'
import ExternalGeocoding from '../pages/main/external/Geocoding'
import ExternalSmsProvider from '../pages/main/external/SmsProvider'
import ExternalTelephonyProvider from '../pages/main/external/TelephonyProvider'
import IntegrationKey from '../pages/main/external/IntegrationKey'

// ADMIN
import AdminUser from '../pages/admin/users/Index'
import AdminPartners from '../pages/admin/partners/Index'
import AdminPos from '../pages/admin/pos/Index'
import AdminPosStatusHistory from '../pages/admin/posStatusHistory/Index'
import AdminSetupHealth from '../pages/admin/setupHealth/Index'
import AdminSystemHealth from '../pages/admin/systemHealth/Index'
import AdminPayment from '../pages/admin/paymentsHistory/Index'
import AdminPartnerPayment from '../pages/admin/partnerPayment/Index'
import AdminDuplicate from '../pages/admin/duplicate/Index'
import AdminSql from '../pages/admin/sql/Index'
import AdminPermissions from '../pages/admin/permissions/Index'
import AdminLanguages from '../pages/admin/languages/Index'
import AdminVersions from '../pages/admin/version/Index'
import AdminMobileApps from '../pages/admin/mobileApps/Index'
import AdminNavigations from '../pages/admin/navigations/Index'
import AdminAdministrators from '../pages/admin/administrators/Index'
import AdminAnalytics from '../pages/admin/analytics/Index'
import AdminAiSupport from '../pages/admin/ai/Index'
import AdminPartnerBonusDistribution from '../pages/admin/partnerBonusDistribution/Index'
import AdminPartnerBonusAccrual from '../pages/admin/partnerBonusAccrual/Index'
import AdminPartnerBonusHistories from '../pages/admin/partnerBonusHistories/Index'
import AdminPartnerConnections from '../pages/admin/partnerConnections/Index'
import AdminSubscriptionServices from '../pages/admin/subscriptionServices/Index'
import AdminSmsUpstreams from '../pages/admin/sms/Upstreams'
import AdminSmsPrices from '../pages/admin/sms/Prices'
import AdminSmsTemplates from '../pages/admin/sms/Templates'
import AdminSmsReport from '../pages/admin/sms/Report'
import AdminTasks from '../pages/admin/tasks/Index'
import AdminTaskCategories from '../pages/admin/taskCategories/Index'
import AdminPosCare from '../pages/admin/posCare/Index'
import AdminPosCalls from '../pages/admin/posCalls/Index'

// DELIVERY
import DeliveryOrders from '../pages/delivery/Orders'
import OrderCreateUpdate from '../pages/delivery/OrderCreateUpdate'

// PARTNER
import PartnerDashboard from '../pages/partner/Dashboard'
import PartnerAnalytics from '../pages/partner/Analytics'
import PartnerPoses from '../pages/partner/pos/Index'
import PartnerPosStatusHistory from '../pages/partner/posStatusHistory/Index'
import PartnerPosPercentages from '../pages/partner/PosPercentages'
import PartnerUsers from '../pages/partner/users/Index'
import PartnerPosesTransactions from '../pages/partner/Transactions'
import MyPartnerTransactions from '../pages/partner/MyPartnerTransactions'
import PartnerBonusAccrual from '../pages/partner/BonusAccrual'
import PartnerBonusHistories from '../pages/partner/BonusHistories'
import PartnerTasks from '../pages/partner/tasks/Index'
import PartnerPosMonitor from '../pages/partner/posMonitor/Index'
import PartnerConnections from '../pages/partner/connections/Index'
import LoginMap from 'pages/auth/Map'
import WebsiteSite from 'pages/website/Site'

const publicRoutes = [
	{ path: "/auth/login", component: <Login /> },
	{ path: "/auth/map", component: <LoginMap /> },
	{ path: "/auth/forgot-password", component: <ForgotPassword /> },
	{ path: "/check/external-menu", component: <CheckExternalMenu /> },
	{ path: "/site/:slug", component: <WebsiteSite /> },
]

const privateRoutes = [
	{ path: "/hello", component: <Hello /> },
	{ path: "/brand", component: <Brand /> },
	{ path: "/analytics/dashboard", component: <AnalyticsDashboard /> },
	{ path: "/analytics/daily", component: <AnalyticsDaily /> },
	{ path: "/analytics/weekly", component: <AnalyticsWeekly /> },
	{ path: "/analytics/monthly", component: <AnalyticsMonthly /> },
	{ path: "/analytics/unit", component: <AnalyticsUnit /> },
	{ path: "/analytics/delivery", component: <AnalyticsDelivery /> },
	{ path: "/analytics/lfl-analysis", component: <AnalyticsLfl /> },
	{ path: "/analytics/rfm", component: <AnalyticsRfm /> },
	{ path: "/analytics/abc-analysis", component: <AnalyticsAbc /> },
	{ path: "/analytics/bcg-matrix", component: <AnalyticsBcg /> },
	{ path: "/analytics/food-cost", component: <AnalyticsFoodCost /> },
	{ path: "/analytics/expense-analysis", component: <AnalyticsExpenseAnalysis /> },
	{ path: "/analytics/recommended-products", component: <AnalyticsRecommendedProducts /> },
	{ path: "/analytics/inventory-abc", component: <AnalyticsInventoryAbc /> },
	{ path: "/analytics/frozen-funds", component: <AnalyticsFrozenFunds /> },
	{ path: "/analytics/comparison", component: <AnalyticsComparison /> },
	{ path: "/analytics/heat-map", component: <AnalyticsHeatMap /> },
	{ path: "/analytics/pop-metrics", component: <AnalyticsPopMetrics /> },
	{ path: "/analytics/ai-insights", component: <AnalyticsAiInsights /> },
	{ path: "/analytics/ai-forecast", component: <AnalyticsAiForecast /> },
	{ path: "/ai-assistant", component: <AiAssistant /> },
	{ path: "/analytics/purchase-price-changes", component: <AnalyticsPurchasePriceChanges /> },
	{ path: "/analytics/price-dynamics", component: <AnalyticsPriceDynamics /> },
	{ path: "/analytics/discounts", component: <AnalyticsDiscounts /> },
	{ path: "/analytics/constructor", component: <AnalyticsConstructor /> },
	{ path: "/subscription", component: <SubscriptionAccount /> },

	{ path: "/kpi-groups", component: <KpiGroups /> },
	{ path: "/kpi-types", component: <KpiTypes /> },
	{ path: "/kpi-scores", component: <KpiScores /> },

	{ path: "/halls", component: <Hall /> },
	{ path: "/halls/scheme/:id", component: <HallScheme /> },
	{ path: "/preparation-places", component: <PreparationPlaces /> },
	{ path: "/print-routes", component: <PrintRoutes /> },
	{ path: "/order-types-subs", component: <OrderTypes /> },
	{ path: "/payment-types", component: <PaymentTypes /> },
	{ path: "/courier-types", component: <CourierTypes /> },
	{ path: "/users-attendances-types", component: <UserAttendanceTypes /> },
	{ path: "/categories", component: <Categories /> },
	{ path: "/product-categories", component: <ProductCategories /> },
	{ path: "/deletion-reasons", component: <DeletionReasons /> },
	{ path: "/product-labels", component: <ProductLabels /> },
	{ path: "/comments", component: <Comment /> },
	{ path: "/auto-add-rule", component: <AutoAddRule /> },
	{ path: "/tables", component: <Table /> },
	{ path: "/elements", component: <Element /> },
	{ path: "/products", component: <Product /> },
	{ path: "/motivations", component: <Motivation /> },
	{ path: "/motivations/create", component: <MotivationCreateUpdate /> },
	{ path: "/motivations/update/:id", component: <MotivationCreateUpdate /> },
	{ path: "/employee-time-rates", component: <EmployeeTimeRate /> },
	{ path: "/employee-time-rates/create", component: <EmployeeTimeRateCreateUpdate /> },
	{ path: "/employee-time-rates/update/:id", component: <EmployeeTimeRateCreateUpdate /> },
	{ path: "/work-schedule", component: <WorkSchedule /> },
	{ path: "/work-shift-types", component: <WorkShiftType /> },
	{ path: "/price-change", component: <PriceСhange /> },
	{ path: "/products/create/:posId", component: <ProductCreateUpdate /> },
	{ path: "/products/update/:posId/:id", component: <ProductCreateUpdate /> },
	{ path: "/products/stop-list", component: <ProductStopList /> },

	{ path: "/pos", component: <Pos /> },
	{ path: "/pos/create", component: <PosCreateUpdate /> },
	{ path: "/pos/update/:id", component: <PosCreateUpdate /> },
	{ path: "/employees", component: <Employee /> },
	{ path: "/employees/create", component: <EmployeeCreateUpdate /> },
	{ path: "/employees/update/:id", component: <EmployeeCreateUpdate /> },
	{ path: "/menu", component: <Menu /> },
	{ path: "/quick-menu", component: <QuickMenu /> },
	{ path: "/suppliers", component: <Supplier /> },
	{ path: "/supplier-types", component: <SuppliersTypes /> },
	{ path: "/payment-pupose-types", component: <Expense /> },
	// План расходов задаётся на экране «Планы» (вкладка «Расходы»), старый экран убран
	{ path: "/expense-plans", component: <Navigate to="/chain/plans?tab=expenses" replace /> },
	{ path: "/cashbox", component: <Cashbox /> },
	{ path: "/cashbox/shift/:cashbox_id", component: <Shift /> },
	{ path: "/clients", component: <Clients /> },
	{ path: "/clients-cards", component: <ClientsCards /> },
	{ path: "/clients-cards-batches", component: <ClientsCardsBatches /> },
	{ path: "/organizations", component: <Organizations /> },
	{ path: "/terminals", component: <Terminals /> },
	{ path: "/devices", component: <Devices /> },
	{ path: "/employee-positions", component: <EmployeePositions /> },
	{ path: "/employee-positions/create", component: <EmployeePositionsCreateUpdate /> },
	{ path: "/employee-positions/update/:id", component: <EmployeePositionsCreateUpdate /> },
	{ path: "/employee-salary", component: <EmployeeSalary /> },
	{ path: "/employee-bonus", component: <EmployeeBonus /> },
	{ path: "/product-order", component: <MenuProductOrder /> },
	{ path: "/attendances", component: <Attendances /> },

	{ path: "/documents-price", component: <DocumentsPrice /> },
	{ path: "/documents-price/create", component: <DocumentsPriceCreateUpdate /> },
	{ path: "/documents-price/preview/:id", component: <DocumentsPricePreview /> },

	{ path: "/documents-in", component: <DocumentsIn /> },
	{ path: "/documents-in/create", component: <DocumentsInCreateUpdate /> },
	{ path: "/documents-in/update/:id", component: <DocumentsInCreateUpdate /> },
	{ path: "/documents-in/preview/:id", component: <DocumentsInPreview /> },

	{ path: "/documents-return", component: <DocumentsReturn /> },
	{ path: "/documents-return/create", component: <DocumentsReturnCreateUpdate /> },
	{ path: "/documents-return/update/:id", component: <DocumentsReturnCreateUpdate /> },
	{ path: "/documents-return/preview/:id", component: <DocumentsReturnPreview /> },

	{ path: "/documents-implementation", component: <DocumentsImplementation /> },
	{ path: "/documents-implementation/create", component: <DocumentsImplementationCreateUpdate /> },
	{ path: "/documents-implementation/preview/:id", component: <DocumentsImplementationPreview /> },

	{ path: "/documents-orders", component: <Orders /> },
	{ path: "/documents-orders/create", component: <OrdersCreateUpdate /> },
	{ path: "/documents-orders/update/:id", component: <OrdersCreateUpdate /> },
	{ path: "/documents-orders/preview/:id", component: <OrdersPreview /> },

	{ path: "/documents-preparation", component: <DocumentPreparation /> },
	{ path: "/documents-preparation/create/:template", component: <DocumentPreparationCreateUpdate /> },
	{ path: "/documents-preparation/preview/:id", component: <DocumentPreparationPreview /> },

	{ path: "/documents-breakdown", component: <DocumentBreakdown /> },
	{ path: "/documents-breakdown/create", component: <DocumentBreakdownCreateUpdate /> },
	{ path: "/documents-breakdown/preview/:id", component: <DocumentBreakdownPreview /> },

	{ path: "/documents-disasembly", component: <DocumentDisasembly /> },
	{ path: "/documents-disasembly/create", component: <DocumentDisasemblyCreateUpdate /> },
	{ path: "/documents-disasembly/preview/:id", component: <DocumentDisasemblyPreview /> },

	{ path: "/service/idocuments-in", component: <ServiceDocumentsIn /> },
	{ path: "/service/idocuments-in/preview/:id", component: <ServiceDocumentsInPreview /> },
	{ path: "/service/idocuments-in/report", component: <ServiceDocumentsInReport /> },
	{ path: "/service/returns-in", component: <ServiceReturnsIn /> },
	{ path: "/service/returns-in/preview/:id", component: <ServiceReturnsInPreview /> },

	{ path: "/inventory-products", component: <InventoryTest /> },
	{ path: "/inventory-products/:id", component: <InventoryTest2 /> },
	{ path: "/inventory-wms", component: <InventoryIndex /> },
	{ path: "/inventory-wms/create", component: <InventoryCreateUpdate /> },
	{ path: "/inventory-wms/update/:id", component: <InventoryCreateUpdate /> },
	{ path: "/inventory-wms/preview/:id", component: <InventoryPreview /> },

	{ path: "/write-off", component: <WriteOff /> },
	{ path: "/write-off/create", component: <WriteOffCreateUpdate /> },
	{ path: "/write-off/update/:id", component: <WriteOffCreateUpdate /> },
	{ path: "/write-off/preview/:id", component: <WriteOffPreview /> },

	{ path: "/loyalty/services", component: <Loyalty /> },
	{ path: "/loyalty/services/create-amount", component: <LoyaltyCreateUpdateAmount /> },
	{ path: "/loyalty/services/update-amount/:id", component: <LoyaltyCreateUpdateAmount /> },
	{ path: "/loyalty/services/create-saving", component: <LoyaltyCreateUpdateSaving /> },
	{ path: "/loyalty/services/update-saving/:id", component: <LoyaltyCreateUpdateSaving /> },
	{ path: "/loyalty/services/create-visit", component: <LoyaltyCreateUpdateVisit /> },
	{ path: "/loyalty/services/update-visit/:id", component: <LoyaltyCreateUpdateVisit /> },

	{ path: "/discount/services", component: <Discount /> },
	{ path: "/discount/services/create", component: <DiscountCreatePromoWizard /> },
	{ path: "/discount/services/create-menu", component: <DiscountCreateUpdateMenuPromo /> },
	{ path: "/discount/services/update-menu/:id", component: <DiscountCreateUpdateMenuPromo /> },
	{ path: "/discount/services/create-buy-get", component: <DiscountCreateUpdateBogo /> },
	{ path: "/discount/services/update-buy-get/:id", component: <DiscountCreateUpdateBogo /> },
	{ path: "/discount/services/create-two-for-one", component: <DiscountCreateUpdateBogo /> },
	{ path: "/discount/services/update-two-for-one/:id", component: <DiscountCreateUpdateBogo /> },
	{ path: "/discount/services/create-bogo", component: <DiscountCreateUpdateBogo /> },
	{ path: "/discount/services/update-bogo/:id", component: <DiscountCreateUpdateBogo /> },
	{ path: "/discount/services/create-gift", component: <DiscountCreateUpdateGift /> },
	{ path: "/discount/services/update-gift/:id", component: <DiscountCreateUpdateGift /> },
	{ path: "/discount/services/create-delivery-discount", component: <DiscountCreateUpdateDeliveryDiscount /> },
	{ path: "/discount/services/update-delivery-discount/:id", component: <DiscountCreateUpdateDeliveryDiscount /> },
	{ path: "/discount/services/create-dish", component: <DiscountCreateUpdateDish /> },
	{ path: "/discount/services/update-dish/:id", component: <DiscountCreateUpdateDish /> },
	{ path: "/discount/services/create-manual", component: <DiscountCreateUpdateManual /> },
	{ path: "/discount/services/create-manual/:id", component: <DiscountCreateUpdateManual /> },
	{ path: "/discount/services/create-product-manual", component: <DiscountCreateUpdateProductManual /> },
	{ path: "/discount/services/update-product-manual/:id", component: <DiscountCreateUpdateProductManual /> },
	{ path: "/discount/services/create-cheque", component: <DiscountCreateUpdateCheque /> },
	{ path: "/discount/services/update-cheque/:id", component: <DiscountCreateUpdateCheque /> },
	{ path: "/discount/services/create-first-order", component: <DiscountCreateUpdateFirstOrder /> },
	{ path: "/discount/services/update-first-order/:id", component: <DiscountCreateUpdateFirstOrder /> },

	{ path: "/discount/promo-codes", component: <DiscountPromocodes /> },
	{ path: "/discount/promo-codes/:id", component: <DiscountPromocodesReport /> },

	{ path: "/price-periods", component: <PricePeriod /> },
	{ path: "/price-categories", component: <PriceCategory /> },

	{ path: "/wms-all", component: <Wms /> },
	{ path: "/service-rating-templates", component: <ServiceRatingTemplates /> },

	{ path: "/tax-categories", component: <TaxCategory /> },

	{ path: "/wms-shifts", component: <WmsShifts /> },

	{ path: "/wms-transfer-wms", component: <WmsTransfer /> },
	{ path: "/wms-transfer-wms/create", component: <WmsTransferCreateUpdate /> },
	{ path: "/wms-transfer-wms/preview/:id", component: <WmsTransferPreview /> },
	{ path: "/wms-transfer-wms/return", component: <WmsTransferReturn /> },

	{ path: "/wms-transfer-branch", component: <WmsTransferToBranch /> },
	{ path: "/wms-transfer-branch/create", component: <WmsTransferToBranchCreate /> },
	{ path: "/wms-transfer-branch/update/:id", component: <WmsTransferToBranchCreate /> },
	{ path: "/wms-transfer-branch/preview/:id", component: <WmsTransferToBranchPreview /> },

	{ path: "/wms-transfer-branch/documents", component: <WmsTransferBranchDocumentIn /> },
	{ path: "/wms-transfer-branch/documents/preview/:id", component: <WmsTransferBranchDocumentInPreview /> },

	{ path: "/service/wms-transfer-pos", component: <WmsTransferToPos /> },
	{ path: "/service/wms-transfer-pos/create", component: <WmsTransferToPosCreate /> },
	{ path: "/service/wms-transfer-pos/update/:id", component: <WmsTransferToPosCreate /> },
	{ path: "/service/wms-transfer-pos/preview/:id", component: <WmsTransferToPosPreview /> },

	{ path: "/service/idocuments-orders", component: <ServiceOrders /> },
	{ path: "/service/idocuments-orders/preview/:id", component: <ServiceOrdersPreview /> },

	{ path: "/cheques-all", component: <Cheques /> },
	{ path: "/cheques-rating", component: <ChequesRating /> },
	{ path: "/guest-feedbacks", component: <GuestFeedbacks /> },
	{ path: "/cheques-by-clients", component: <ChequesByClients /> },
	{ path: "/cheques-by-counterparties", component: <ChequesByCounterparties /> },
	{ path: "/cheques-by-counterparties/:type/:id", component: <ChequesByCounterparty /> },
	{ path: "/cheques-template", component: <ChequeTemplateLegacy /> },
	{ path: "/cheque-templates", component: <ChequeTemplates /> },
	{ path: "/cheque-templates/create", component: <ChequeTemplatesCreateUpdate /> },
	{ path: "/cheque-templates/update/:id", component: <ChequeTemplatesCreateUpdate /> },
	{ path: "/synchronizations", component: <Synchronization /> },

	{ path: "/report-suppliers", component: <ReportSuppliers /> },
	{ path: "/report-suppliers/debts/:supplier_id", component: <ReportSuppliersInner /> },
	{ path: "/report-suppliers-movements", component: <ReportSupplierMovements /> },
	{ path: "/report-employees", component: <ReportEmployees /> },
	{ path: "/report-employees/debts/:employee_id", component: <ReportEmployeesInner /> },
	{ path: "/report-clients", component: <ReportClients /> },
	{ path: "/report-clients/debts/:client_id", component: <ReportClientsInnerDebts /> },
	{ path: "/report-organizations", component: <ReportOrganizations /> },
	{ path: "/report-organizations/debts/:organization_id", component: <ReportOrganizationsInnerDebts /> },

	{ path: "/report-safe", component: <ReportPosSafe /> },
	{ path: "/report-bank", component: <ReportPosBank /> },
	{ path: "/report-average-cheque", component: <ReportAverageCheque /> },
	{ path: "/report-balance", component: <ReportBalance /> },
	{ path: "/report-calculation", component: <ReportCalculation /> },
	{ path: "/report-employee", component: <ReportEmployee /> },
	{ path: "/report-expenses", component: <ReportExpenses /> },
	{ path: "/report-gross-income", component: <ReportGrossIncome /> },
	{ path: "/report-incomes", component: <ReportIncomes /> },
	{ path: "/report-write-off", component: <ReportWriteOff /> },
	{ path: "/report-menu", component: <ReportMenu /> },
	{ path: "/report-menu2", component: <ReportMenu2 /> },
	{ path: "/report-olap", component: <ReportOlap /> },
	{ path: "/report-products", component: <ReportProducts /> },
	{ path: "/report-sales", component: <ReportSales /> },
	{ path: "/report-preparation", component: <ReportPreparation /> },
	{ path: "/report-cash-flow", component: <ReportCashFlow /> },
	{ path: "/report-cheques-summary", component: <ReportSummaryCheques /> },
	{ path: "/report-summary", component: <ReportSummary /> },
	{ path: "/report-z", component: <ReportZ /> },
	{ path: "/report-check-point", component: <ReportCheckPoint /> },

	{ path: "/chain/plans", component: <ChainPlans /> },
	// Бывшая заглушка ввода планов — теперь экран «Планы»
	{ path: "/chain/poses-plans", component: <Navigate to="/chain/plans" replace /> },
	{ path: "/chain/balance", component: <ChainBalance /> },
	{ path: "/chain/element-incomes", component: <ChainElementIncomes /> },
	{ path: "/chain/element-sales", component: <ChainElementSales /> },
	{ path: "/chain/product-sales", component: <ChainProductSales /> },
	{ path: "/chain/external-transfer", component: <ChainWmsTransferPos /> },
	{ path: "/chain/external-transfer-summary", component: <ChainWmsTransferPosSummary /> },

	{ path: "/chain/report-sales", component: <ChainSales /> },
	//{ path: "/chain/report-abc", component: <ChainAbc /> },
	{ path: "/chain/report-plan-fact", component: <ChainPlanFact /> },
	{ path: "/chain/report-contour-market", component: <ChainContourMarket /> },
	{ path: "/chain/report-hours", component: <ChainHours /> },
	{ path: "/chain/report-cheque-rating", component: <ChainChequeRating /> },
	{ path: "/chain/report-service-rating", component: <ChainServiceRating /> },
	{ path: "/chain/report-courier-tracking", component: <ChainDeliveryTracking /> },
	{ path: "/chain/report-expenses", component: <ChainExpenses /> },
	{ path: "/chain/report-profit", component: <ChainProfit /> },
	{ path: "/chain/report-write-offs", component: <ChainWriteOffs /> },
	{ path: "/chain/report-payments", component: <ChainPayments /> },
	{ path: "/chain/report-losses", component: <ChainLosses /> },

	{ path: "/external-menu", component: <ExternalGroups /> },
	{ path: "/external-menu/:id", component: <ExternalMenu /> },
	{ path: "/external-integrations", component: <IntegrationGroup /> },
	{ path: "/external-integrations/create", component: <IntegrationUpdate /> },
	{ path: "/external-integrations/update/:id", component: <IntegrationUpdate /> },
	{ path: "/external-integrations/check/:id", component: <IntegrationMenuCheck /> },
	{ path: "/external-delivery-rules", component: <ExternalDeliveryRules /> },
	{ path: "/external-delivery-zones", component: <ExternalDeliveryZones /> },
	{ path: "/external-telegram-bots", component: <TelegramBots /> },
	{ path: "/external-website", component: <WebsiteBuilder /> },
	{ path: "/external-mobile-app", component: <MobileAppBuilder /> },
	{ path: "/external-self-order", component: <SelfOrderBuilder /> },
	{ path: "/external-call-center", component: <ExternalCallCenter /> },
	{ path: "/external-qr-menu", component: <ExternalQrMenuTable /> },
	{ path: "/external-pos-orders", component: <ExternalPosOrders /> },
	{ path: "/external-couriers", component: <ExternalCouriers /> },
	{ path: "/external-courier-types", component: <ExternalCouriers /> },
	{ path: "/external-geocoding", component: <ExternalGeocoding /> },
	{ path: "/external-sms-provider", component: <ExternalSmsProvider /> },
	{ path: "/external-telephony-provider", component: <ExternalTelephonyProvider /> },
	{ path: "/external-integration-keys", component: <IntegrationKey /> },

	{ path: "/help", component: <Help /> },

	{ path: "/finance/accounts", component: <FinanceAccounts /> },
	{ path: "/finance/accounts/:id/transactions", component: <FinanceAccountTransactions /> },
	{ path: "/finance/profit-loss", component: <FinanceProfitLoss /> },
	{ path: "/finance/balance-sheet", component: <FinanceBalanceSheet /> },
	{ path: "/finance/product-profitability", component: <FinanceProductProfitability /> },
	{ path: "/finance/fixed-assets", component: <FinanceFixedAssets /> },
	{ path: "/favorite-navigation", component: <FavoriteNavigation /> },

	{ path: "/notifications-center", component: <NotificationCenter /> },
	{ path: "/notification-settings", component: <NotificationSettings /> },
	{ path: "/sms-messages", component: <SmsMessages /> },
	{ path: "/stock-alerts", component: <StockAlerts /> },
	{ path: "/audit-logs", component: <AuditLogs /> },
	{ path: "/setup-health", component: <SetupHealth /> },
	{ path: "/telegram-sending", component: <TelegramSending /> },
	{ path: "/sms-sending", component: <SmsSending /> },
	{ path: "/sms-templates", component: <SmsTemplates /> },

	{ path: "/payment", component: <Payment /> },

	{ path: "/calendar", component: <Calendar /> },
]

const deliveryPrivateRoutes = [
	// delivery
	{ path: "/delivery/orders", component: <DeliveryOrders /> },
	{ path: "/delivery/create", component: <OrderCreateUpdate /> },
	{ path: "/delivery/update/:cheque_id", component: <OrderCreateUpdate /> },
	{ path: "/delivery/cheques-rating", component: <ChequesRating /> },
]

const adminPrivateRoutes = [
	// admin
	{ path: "/admin/users", component: <AdminUser /> },
	{ path: "/admin/partners", component: <AdminPartners /> },
	{ path: "/admin/partner-connections", component: <AdminPartnerConnections /> },
	{ path: "/admin/partner-bonus-distribution", component: <AdminPartnerBonusDistribution /> },
	{ path: "/admin/partner-bonus-accrual", component: <AdminPartnerBonusAccrual /> },
	{ path: "/admin/partner-bonus-histories", component: <AdminPartnerBonusHistories /> },
	{ path: "/admin/subscription-services", component: <AdminSubscriptionServices /> },
	{ path: "/admin/sms-upstreams", component: <AdminSmsUpstreams /> },
	{ path: "/admin/sms-prices", component: <AdminSmsPrices /> },
	{ path: "/admin/sms-templates", component: <AdminSmsTemplates /> },
	{ path: "/admin/sms-report", component: <AdminSmsReport /> },
	{ path: "/admin/poses", component: <AdminPos /> },
	{ path: "/admin/pos-status-history", component: <AdminPosStatusHistory /> },
	{ path: "/admin/pos-care", component: <AdminPosCare /> },
	{ path: "/admin/pos-calls", component: <AdminPosCalls /> },
	{ path: "/admin/setup-health", component: <AdminSetupHealth /> },
	{ path: "/admin/system-health", component: <AdminSystemHealth /> },
	{ path: "/admin/payments-history", component: <AdminPayment /> },
	{ path: "/admin/partner-payments", component: <AdminPartnerPayment /> },
	{ path: "/admin/duplicate", component: <AdminDuplicate /> },
	{ path: "/admin/sql", component: <AdminSql /> },
	{ path: "/admin/permissions", component: <AdminPermissions /> },
	{ path: "/admin/languages", component: <AdminLanguages /> },
	{ path: "/admin/versions", component: <AdminVersions /> },
	{ path: "/admin/mobile-apps", component: <AdminMobileApps /> },
	{ path: "/admin/navigations", component: <AdminNavigations /> },
	{ path: "/admin/administrators", component: <AdminAdministrators /> },
	{ path: "/admin/analytics", component: <AdminAnalytics /> },
	{ path: "/admin/ai-support", component: <AdminAiSupport /> },
	{ path: "/admin/tasks", component: <AdminTasks /> },
	{ path: "/admin/task-categories", component: <AdminTaskCategories /> },
]

const partnerPrivateRoutes = [
	// partner
	{ path: "/partner/dashboard", component: <PartnerDashboard /> },
	{ path: "/partner/analytics", component: <PartnerAnalytics /> },
	{ path: "/partner/poses", component: <PartnerPoses /> },
	{ path: "/partner/pos-status-history", component: <PartnerPosStatusHistory /> },
	{ path: "/partner/connections", component: <PartnerConnections /> },
	{ path: "/partner/users", component: <PartnerUsers /> },
	{ path: "/partner/transactions", component: <PartnerPosesTransactions /> },
	{ path: "/partner/partners-transactions", component: <MyPartnerTransactions /> },
	{ path: "/partner/pos-percentages", component: <PartnerPosPercentages /> },
	{ path: "/partner/bonus-accrual", component: <PartnerBonusAccrual /> },
	{ path: "/partner/bonus-histories", component: <PartnerBonusHistories /> },
	{ path: "/partner/tasks", component: <PartnerTasks /> },
	{ path: "/partner/pos-monitor", component: <PartnerPosMonitor /> },
]

export {
	publicRoutes,
	privateRoutes,
	adminPrivateRoutes,
	deliveryPrivateRoutes,
	partnerPrivateRoutes
}